import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, image, listBox, rightMargin, title, wrapper } from './LastPageStyle';
import imgPlan from '../../assets/media/pl1-bus1.jpg';
import IndustryArea from '../../components/IndustryArea';

const PlanningLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title}>Mit ZMC zu einem integrierten Planungsprozess</div>
                <h2>Von der Analyse zum Konzept und umgesetztem S&OP</h2>
                <p>
                    Zellweger Management Consultants (ZMC) bietet Beratungs-, Umsetzungs- &amp; Trainings- sowie
                    Durchführungsdienstleistungen zur Einführung und Weiterentwicklung von S&OP an.
                </p>
                <div className={wrapper}>
                    <img className={`${image} ${rightMargin}`} src={imgPlan} alt="Hände" />
                    <div className={listBox}>
                        <ul>
                            <li>360° «Planning Excellence»-Assessment</li>
                            <li>S&amp;OP und Integrated Business Planning (IBP)</li>
                            <li>Demand &amp; Supply Planning – inkl. Aktions- und Promotionsplanung, Phase -in/-out</li>
                            <li>End to End-Supply Chain Strategie &amp; -Footprint und Kapazitätsplanung</li>
                            <li>Supply Chain Optimierung und Simulation</li>
                            <li>Supply Chain Controlling</li>
                            <li>Sales Forecasting, Advanced und Predictive Analytics (AI)</li>
                            <li>KI, Demand Sensing, Demand Shaping</li>
                            <li>Advanced Supply Chain-Planning</li>
                            <li>Supply Chain Prozesse/Planungsprozesse</li>
                            <li>Supply Chain Organisation</li>
                            <li>Supply Chain Applikationen/Planungsapplikationen: APS</li>
                        </ul>
                    </div>
                </div>
                <h2>Namhafte Kunden vertrauen uns</h2>
                <p>Internationale Unternehmen wählen uns als Partner, um «Excellence» im Planning zu erreichen.</p>
                <IndustryArea />
                <h2>Nachhaltige Resultate und ein attraktiver Payback</h2>
                <p>
                    Sie setzen auf ein erfahrenes Team. Unser Fokus auf «Business Excellence» und unsere ausgewiesene
                    Umsetzungsstärke garantieren Ihnen nachhaltige Resultate und eine rasche Amortisation der
                    Projektkosten.
                </p>
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default PlanningLastPage;
